export const Colors = {
  primary: "#D6E1D3",
  secondary: "#F9F4F0",
  white: "#FFF",
  black: "#333",
};
